import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
const FinancePageTile = lazy(() => import("./FinancePageTile"));
const Router = () => {
    return (_jsx(BrowserRouter, { children: _jsx(Suspense, { fallback: _jsx("div", { children: "Loading..." }), children: _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsx(FinancePageTile, {}) }, "finance-marketing") }) }) }));
};
export default Router;
